import { useQuery } from '@tanstack/react-query';
import { listAppTemplates } from '@wix/ambassador-devcenter-apps-v1-app-template/http';
import type { AppTemplate } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { useHttpClient } from '@wix/fe-essentials/react';

export const useTemplatesQuery = () => {
  const httpClient = useHttpClient();

  return useQuery<AppTemplate[], Error>({
    queryKey: ['templates'],
    queryFn: async (): Promise<AppTemplate[]> => {
      const {
        data: { appTemplates },
      } = await httpClient.request(listAppTemplates({}));
      const scratchCliTemplate = {
        id: 'd4fb8f1e-ea6f-4d66-9d96-cd2e0c6643e1',
        title: 'Start From Scratch',
        subtitle: 'Build an app from scratch on Wix CLI.',
        thumbnail:
          'https://static.wixstatic.com/media/2178dd_6390744a18454232801b9fff54a1218b~mv2.png',
        developmentTools: ['CLI'],
        clonePrompt: [
          {
            packageManager: 'NPM',
            prompt: 'create @wix/app@latest',
          },
          {
            packageManager: 'YARN',
            prompt: 'create @wix/app',
          },
        ],
      };
      appTemplates.unshift(scratchCliTemplate as AppTemplate);
      return appTemplates || [];
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
